{
  "closeText": "Close"
}
